module.exports = __webpack_public_path__ + "static/img/07.9a09ec78.png";